export default __webpack_public_path__ + "static/media/icon-Facebook.ad8d8d1d.svg";